// aliases which should be displayed in one line Upgrades:

export const UPGRADE_ALIASES = ['digital_protection', 'insurance', 'hydrophobic'];

export const SUMMARY_TITLES = {
    'trans-amber': 'Transitions™ GEN S™ Amber',
    'trans-amethyst': 'Transitions™ GEN S™ Amethyst',
    'trans-brown': 'Transitions™ GEN S™ Brown',
    'trans-emerald': 'Transitions™ GEN S™ Emerald',
    'trans-gray': 'Transitions™ GEN S™ Gray',
    'trans-green': 'Transitions™ GEN S™ Green',
    'trans-ruby': 'Transitions™ GEN S™ Ruby',
    'trans-sapphire': 'Transitions™ GEN S™ Sapphire',
    'trans-xtra-active-brown': 'Transitions™ XTRActive® Brown',
    'trans-xtra-active-gray': 'Transitions™ XTRActive® Gray',
    'trans-xtra-active-polar-gray': 'Transitions™ XTRActive® Polarized™ Gray',
};
